import ButtonLayout from "../ButtonLayout"
import clsx from "clsx"
export default function WhiteButton({
    children,
    className,
    icon = null
}){
    return (
        <ButtonLayout
        className={clsx(
            "bg-white",
            className
        )}
        icon={icon}>
            {children}
        </ButtonLayout>
    )
}